import {
    NinchatActionType,
    NinchatRequestIdentityVerifyAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const requestIdentityVerifyAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatRequestIdentityVerifyAccessAction}`,
    async (arg: NinchatActionParams<NinchatRequestIdentityVerifyAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatRequestIdentityVerifyAccessAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
